
import { Component, Ref, Vue, } from 'vue-property-decorator';
import { validationMixin, } from 'vuelidate';
import { isBadRequestResult, } from '~/api/error-helpers';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import CreatePasswordInput from '~/components/self-serve/create-password-input/create-password-input.vue';
import DetailsSection from '~/components/self-serve/details-section/details-section.vue';
import Tooltip from '~/components/tooltip/tooltip.vue';
import { preventLeaveMixin, } from '~/mixins/prevent-leave-mixin';
import { passwordRules, } from '~/utils/validators';

@Component({
	components: {
		CreatePasswordInput,
		FeedbackBox,
		HeaderText,
		Tooltip,
		DetailsSection,
	},
	metaInfo: {
		title: 'Digital billing - Set login details - Southern Water',
	},
	mixins: [
		preventLeaveMixin,
		validationMixin,
	],
	validations: {
		password: passwordRules,
	},
})
export default class SetLoginDetails extends Vue {
	apiError: string | null = null;
	password = '';

	mounted() {
		Store.commit.register.setStep(3);
	}

	contactUsLocation = Store.getters.getGlobalConfigValue('ContactUsLocation');

	@Ref()
	readonly passwordControl!: CreatePasswordInput;

	setFocus() {
		((this.$refs.passwordControl as Vue).$refs.passwordInput as Element as HTMLElement).focus();
	}

	get customerDetails() {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return Store.state.register.customerDetails!;
	}

	handleSubmit() {
		this.apiError = null;
		const currentForm = this.$v;
		currentForm.$touch();
		window.scrollTo(0, 0);
		if (currentForm.$pending || currentForm.$error) {
			return;
		}

		Store.commit.showSpinner();

		this.$selfServeApi.registerAccountSubmitRegistrationForLinearRegistrationCreate({
			customerNumber: this.customerDetails.customerNumber,
			lastName: this.customerDetails.customerLastName,
			emailId: this.customerDetails.customerEmail,
			password: this.password,
			paperlessFlag: true,
		})
			.then(() => {
				// eslint-disable-next-line @typescript-eslint/no-empty-function
				return this.$router.push('./verification').catch(() => { });
			})
			.catch((error) => {
				this.apiError = `Please wait a few minutes and try again. If the problem persists, please <a target="_blank" href=${this.contactUsLocation}>contact us</a>.`;
				if (isBadRequestResult(error) && Array.isArray(error.errors) && error.errors[0]?.message) {
					this.apiError = error.errors[0].message;
				}
			}).finally(() => Store.commit.hideSpinner());
	}

	focusRef(ref: string) {
		(this.$refs[ref] as HTMLElement)?.focus();
	}
}
